import { render, staticRenderFns } from "./AddPaymentMethod.vue?vue&type=template&id=13c9c7da&"
import script from "./AddPaymentMethod.vue?vue&type=script&lang=js&"
export * from "./AddPaymentMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports